import React, { useEffect, useRef, useState } from 'react';

import { Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';
import { Link, useHistory, useNavigate } from 'react-router-dom';

import ChatMessLeft from '../../components/Chat/ChatMessLeft';
import ChatMessRight from '../../components/Chat/ChatMessRight';
import { useDispatch, useSelector } from 'react-redux';
import { getChatSingle } from '../../redux/actions/chat/getChatSingle';
import { getChatMessages } from '../../redux/actions/chat/getChatMessages';
import { format } from 'date-fns';
import { socket } from '../../utils/socket';
import { useForm } from 'react-hook-form';
import Input from '../../components/Input/Input';
import { sendMessage } from '../../redux/actions/chat/sendMessage';
import clsx from 'clsx';
import { resetDeleteChat, resetGetChatMessages, resetGetChatSingle, resetSendMessage } from '../../redux/slices/chat.slice';
import InfiniteScroll from 'react-infinite-scroll-component';
import Loading from '../../components/Loading/Loading';
import VacancyEmpty from '../../components/List/Vacancy/VacancyEmpty';
import Swal from 'sweetalert2';
import { deleteChat } from '../../redux/actions/chat/deleteChat';
import { toast } from 'react-toastify';
import VacancyCellManager from '../../components/List/Vacancy/VacancyCellManager';
import { Modal } from 'antd';
import SelectionPerformer from '../SelectionPerformer';
import ProfileIndex from '../Profile/ProfileIndex';
import { getLinkVacancy } from '../../components/FeedBacks/OtherFeedbacks';
import { readChat } from '../../redux/actions/chat/readChat';

export const getLinkUserProfile = ({ type, id }) => {
  switch (type) {
    case 'staff':
      return `/edit/user/${id}`;
    case 'employer':
    case 'ie':
      return `/user/${id}`;
    case 'candidate':
      return `/profile/${id}`;

    default:
      break;
  }
};

export default function ChatContent({ chatId }) {
  const dispatch = useDispatch();
  const [chatData, setChatData] = useState(null);
  const [messages, setMessages] = useState([]);
  const [openCandidateModal, setOpenCandidateModal] = useState(false);
  const [openUser, setOpenUser] = useState(false);
  //   const tabs = [{}]
  const {
    getChatSingle: { data: getChatSingleData, error: getChatSingleError, loading: getChatSingleLoading },
    getChatMessages: { data: getChatMessagesData, error: getChatMessagesError, loading: getChatMessagesLoading },
    sendMessage: { data: sendMessageData, error: sendMessageError, loading: sendMessageLoading },
    deleteChat: { data: deleteChatData, error: deleteChatError, loading: deleteChatLoading },
  } = useSelector((state) => state.chat);
  useEffect(() => {
    if (deleteChatError) {
      const errorData = deleteChatError?.payload?.data?.detail;
      const errorStatus = deleteChatError?.payload?.status;
      if (errorData) {
        toast.error(errorData, { theme: 'colored', autoClose: '3000' });
      }
      // dispatch(resetCreateVacancy());
    }
  }, [deleteChatError]);
  useEffect(() => {
    if (deleteChatData) {
      Swal.fire({
        title: 'Чат удален',
        showConfirmButton: false,
        timer: 1000,
        timerProgressBar: true,
      });
      dispatch(resetDeleteChat());
      navigate(-1);
    }
  }, [deleteChatData]);

  useEffect(() => {
    if (sendMessageData) {
      form.setValue('message', '');
      dispatch(readChat(chatId));
      dispatch(resetSendMessage());
    }
  }, [sendMessageData]);

  const {
    getMe: { data: getMeData, error: getMeError, loading: getMeLoading },
  } = useSelector((state) => state.user);
  const [cursor, setCursor] = useState();
  useEffect(() => {
    if (getChatSingleData && getChatMessagesData && getMeData) {
      let leftUser;
      let rightUser;
      const findSelf = getChatSingleData?.sides?.find((side) => side?.user?.id == getMeData?.id);

      if (findSelf) {
        rightUser = { ...findSelf?.user, isSelf: true };
        const leftUserFind = getChatSingleData?.sides?.find((side) => side?.user?.id !== findSelf?.user?.id);
        leftUser = leftUserFind?.user ?? leftUserFind?.employer;
      } else {
        rightUser = getChatSingleData?.sides[0]?.user ?? getChatSingleData?.sides[0]?.employer ?? getChatSingleData?.sides[0]?.candidate;
        leftUser = getChatSingleData?.sides[1]?.user ?? getChatSingleData?.sides[1]?.employer ?? getChatSingleData?.sides[1]?.candidate;
      }
      const messagesWithSide = getChatMessagesData?.results?.map((mess) => {
        const sender = mess?.from_user;
        return { ...mess, side: sender?.id == getMeData?.id ? 'right' : 'left', isSelf: sender?.id == getMeData?.id, created_at: format(mess?.created_at, 'HH:mm dd.MM.yy') };
      });
      setMessages((prev) => [...prev, ...messagesWithSide]);
      setChatData({ leftUser, rightUser });
      dispatch(readChat(chatId));
    }
  }, [getChatSingleData, getChatMessagesData, getMeData]);
  console.log(chatData);

  useEffect(() => {
    dispatch(getChatSingle(chatId));
  }, [chatId]);
  useEffect(() => {
    if (chatId) {
      dispatch(getChatMessages({ chatId, ...(cursor && { cursor }) }));
    }
  }, [chatId, cursor]);
  useEffect(() => {
    if (chatId) {
      setMessages([]);
    }
  }, [chatId]);

  useEffect(() => {
    return () => {
      dispatch(resetGetChatSingle());
      dispatch(resetGetChatMessages());
    };
  }, []);
  // console.log();

  useEffect(() => {
    if (socket.connected) {
      socket.emit(
        'subscribe_chat',
        {
          chat_id: chatId,
        },
        (response) => {
          console.log(response);
        },
      );
      socket.on('chat_message', (data) => {
        console.log();

        let newMessage = { ...data, side: data?.from_user?.id == getMeData?.id ? 'right' : 'left', isSelf: data?.from_user?.id == getMeData?.id, created_at: format(data?.created_at, 'HH:mm dd.MM.yy') };

        setMessages((prev) => [newMessage, ...prev]);

        console.log(data);
      });
      console.log('Subscribe chat');
    }
  }, [socket.connected]);

  const form = useForm();
  const onSendMessage = (data) => {
    dispatch(
      sendMessage({
        chat_id: chatId,
        content_type: 'text',
        text: data?.message,
        candidate_id: null,
      }),
    );
  };

  const HeadUser = ({ inn, isSupport, type, isReverse, name, isSelf, id }) => {
    return (
      <div
        className="flex items-center w-auto gap-4 cursor-pointer"
        style={{ flexDirection: isReverse ? 'row-reverse' : 'row' }}
        onClick={() => {
          navigate(getLinkUserProfile({ type, id }));
        }}>
        <div className="">
          <div alt="" className={clsx('w-7 flex items-center justify-center sm:w-12 h-7 sm:h-12 rounded-full  border-2 ', !isSelf && 'border-b-1')} style={isSelf ? { borderColor: 'rgba(0, 178, 164, 0.2)' } : {}}>
            {isSupport ? (
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24">
                <path fill="rgba(0,0,0,0.6)" d="M12 1c-5 0-9 4-9 9v7a3 3 0 0 0 3 3h3v-8H5v-2a7 7 0 0 1 7-7a7 7 0 0 1 7 7v2h-4v8h4v1h-7v2h6a3 3 0 0 0 3-3V10c0-5-4.03-9-9-9" />
              </svg>
            ) : (
              <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24">
                <path fill={!isSelf ? 'rgba(0,0,0,0.6)' : 'rgb(0, 178, 164)'} d="M12 4a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m0 10c4.42 0 8 1.79 8 4v2H4v-2c0-2.21 3.58-4 8-4"></path>
              </svg>
            )}
          </div>
        </div>
        <div className="flex flex-col gap-1 leading-tight w-auto" style={{ alignItems: isReverse ? 'end' : 'start' }}>
          <div className="text-lg mt-1 font-semibold flex items-center ">
            <span className={clsx('mr-1', isSelf ? 'text-button font-bold' : 'text-gray-700 ')}>
              {isSupport ? (
                'Тех.поддержка'
              ) : isSelf ? (
                'Вы'
              ) : (
                <>
                  {isReverse ? (
                    <>
                      {name} -<span style={{ opacity: '0.7' }}> {id} </span>
                    </>
                  ) : (
                    <>
                      <span style={{ opacity: '0.7' }}>{id} -</span> {name}
                    </>
                  )}

                  {inn && <div style={{ opacity: '0.7', marginTop: '4px', fontSize: '14px', ...(isReverse && { textAlign: 'right' }) }}>ИНН {inn}</div>}
                </>
              )}
            </span>
          </div>
          {/* {!isSelf && !isSupport && (
            <div className="flex items-center">
              <span className="text-green-500 flex items-center">
                <svg width="15" height="15" className="mt-1">
                  <circle cx="5" cy="5" r="5" fill="currentColor"></circle>
                </svg>
              </span>
              <span className="text-sm text-gray-600">Онлайн</span>
            </div>
          )} */}
        </div>
      </div>
    );
  };
  const chatContainerRef = useRef();

  useEffect(() => {
    if (messages?.length) {
      // chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
    }
  }, [messages]);

  console.log(messages);
  console.log(cursor);
  const navigate = useNavigate();
  const handleDelete = () => {
    Swal.fire({
      title: 'Вы действительно хотите удалить чат?',
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Да',
      cancelButtonText: 'Нет',
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(deleteChat(chatId));
      }
    });
  };
  function classNames(...classes) {
    return classes.filter(Boolean).join(' ');
  }
  const employerVacancy = getChatSingleData?.sides?.find((side) => side?.employer?.id == getChatSingleData?.vacancy?.employer?.id);
  if (getChatSingleLoading) {
    return <Loading />;
  }
  if (getChatSingleError) {
    return (
      <VacancyEmpty style={{ fontSize: '22px', height: '100%', paddingBottom: '40px', opacity: 1, flexDirection: 'column' }}>
        <div className="opacity-50">Чат не найден</div>{' '}
        <button
          type="button"
          className="text-center border rounded py-2 px-2  text-button border-button border-1 hover:text-white bg-white hover:bg-button transition ease-in-out duration-300 text-base font-normal mt-4 w-[100px]"
          onClick={() => {
            navigate(-1);
          }}>
          Назад
        </button>
      </VacancyEmpty>
    );
  }
  const isShowSendCandidate = getChatSingleData?.type != 'employer_candidate' && getChatSingleData?.type != 'staff_candidate';
  const employerInSidesSupport = chatData?.rightUser?.type == 'staff' ? chatData?.leftUser : chatData?.rightUser;
  return (
    <div className="flex flex-1 w-full h-full">
      {deleteChatLoading && (
        <div className="fixed w-[100vw] h-[100vh] top-0 left-0 r-0 b-0 z-[1000]">
          {' '}
          <Loading />
        </div>
      )}

      <div className="flex sm:p-1 flex-col  border-gray-200 shadow-md rounded-lg flex-grow">
        <div className="flex sm:items-center justify-between p-6  border-b-2 max-h-24 border-gray-200">
          {getChatSingleData?.vacancy ? (
            <>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr auto', alignItems: 'center', justifyContent: 'center', width: '100%', position: 'relative' }}>
                <div className="text-lg mt-1 font-semibold flex items-center " style={{ fontSize: '22px', justifySelf: 'center', alignSelf: 'start', position: 'absolute', top: '-57px', left: '50%', transform: 'translateX(-50%)' }}>
                  <span
                    className={clsx('cursor-pointer', 'text-gray-700 ')}
                    style={{ transform: '' }}
                    onClick={() => {
                      navigate(getLinkVacancy(getChatSingleData?.vacancy));
                    }}>
                    Вакансия «{getChatSingleData?.vacancy?.name}»
                  </span>
                </div>
                <HeadUser name={chatData?.leftUser?.full_name ?? chatData?.leftUser?.name} isSelf={chatData?.leftUser?.isSelf} type={chatData?.leftUser?.type} id={chatData?.leftUser?.id} inn={chatData?.leftUser?.inn} />
                <div className="" style={{ justifySelf: 'end' }}>
                  <VacancyCellManager
                    styleSelectIcon={{ width: '14px', height: '14px', marginRight: '-16px' }}
                    manager={getChatSingleData?.vacancy?.manager ? getChatSingleData?.vacancy?.manager : null}
                    size={210}
                    style={{ marginRight: '-16px', whiteSpace: 'nowrap', fontSize: '16px' }}
                    editManger={false}
                    num={getChatSingleData?.vacancy?.id}
                    styleIcon={{ minWidth: '20px', height: '20px' }}
                    styleSelect={{ fontSize: '16px' }}
                    text={'Добавить менеджера'}
                  />
                </div>
              </div>

              {/* <div className="h-[48px] flex items-center justify-between w-full">
                <div className="flex flex-col text-lg items-start ">
                  <div
                    className="cursor-pointer"
                    onClick={() => {
                      navigate(getLinkVacancy(getChatSingleData?.vacancy));
                    }}>
                    Вакансия «{getChatSingleData?.vacancy?.name}»
                  </div>
                  <div
                    className="text-sm text-gray-400 cursor-pointer"
                    onClick={() => {
                      navigate(getLinkUserProfile({ type: employerVacancy?.type, id: employerVacancy?.employer?.id }));
                    }}>
                    {' '}
                    {employerVacancy?.employer?.name}
                  </div>
                </div>
                <div className="">
                  <VacancyCellManager
                    styleSelectIcon={{ width: '14px', height: '14px', marginRight: '-16px' }}
                    manager={getChatSingleData?.vacancy?.manager ? getChatSingleData?.vacancy?.manager : null}
                    size={210}
                    style={{ marginRight: '-16px', whiteSpace: 'nowrap', fontSize: '16px' }}
                    editManger={false}
                    num={getChatSingleData?.vacancy?.id}
                    styleIcon={{ minWidth: '20px', height: '20px' }}
                    styleSelect={{ fontSize: '16px' }}
                    text={'Добавить менеджера'}
                  />
                </div>
              </div> */}
            </>
          ) : getChatSingleData?.type == 'support' ? (
            <div style={{ display: 'grid', gridTemplateColumns: '1fr auto', alignItems: 'center', justifyContent: 'center', width: '100%', position: 'relative' }}>
              <div className="text-lg mt-1 font-semibold flex items-center " style={{ fontSize: '22px', justifySelf: 'center', alignSelf: 'start', position: 'absolute', top: '-57px', left: '50%', transform: 'translateX(-50%)' }}>
                <span className={clsx('', 'text-gray-700 ')} style={{ transform: '' }}>
                  Тех.поддержка
                </span>
              </div>
              <HeadUser name={employerInSidesSupport?.full_name ?? employerInSidesSupport?.name} isSelf={employerInSidesSupport?.isSelf} type={employerInSidesSupport?.type} id={employerInSidesSupport?.id} inn={employerInSidesSupport?.inn} />

              <div className="" style={{ justifySelf: 'end' }}>
                <VacancyCellManager
                  isSupport
                  chatId={chatId}
                  styleSelectIcon={{ width: '14px', height: '14px', marginRight: '-16px' }}
                  manager={getChatSingleData?.manager ? getChatSingleData?.manager : null}
                  size={210}
                  style={{ marginRight: '-16px', whiteSpace: 'nowrap', fontSize: '16px' }}
                  editManger={false}
                  num={getChatSingleData?.id}
                  styleIcon={{ minWidth: '20px', height: '20px' }}
                  styleSelect={{ fontSize: '16px' }}
                  text={'Добавить менеджера'}
                />
              </div>
            </div>
          ) : (
            <>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', alignItems: 'center', justifyContent: 'center', width: '100%', position: 'relative' }}>
                <div className="text-lg mt-1 font-semibold flex items-center " style={{ fontSize: '22px', justifySelf: 'center', alignSelf: 'start', position: 'absolute', top: '-57px', left: '50%', transform: 'translateX(-50%)' }}>
                  <span className={clsx('', 'text-gray-700 ')} style={{ transform: '' }}>
                    {getChatSingleData?.type == 'staff_staff' ? 'Диалог Менеджеров' : getChatSingleData?.type == 'staff_candidate' ? 'Диалог Менеджера/Соискателя' : getChatSingleData?.type == 'employer_candidate' ? 'Диалог Контрагента/Соискателя' : ''}
                  </span>
                </div>
                <HeadUser name={chatData?.leftUser?.full_name ?? chatData?.leftUser?.name} type={chatData?.leftUser?.type} id={chatData?.leftUser?.id} inn={chatData?.leftUser?.inn} />
                <div style={{ justifySelf: 'center' }}>
                  <VacancyCellManager
                    isSupport
                    chatId={chatId}
                    styleSelectIcon={{ width: '14px', height: '14px', marginRight: '-16px' }}
                    manager={getChatSingleData?.manager ? getChatSingleData?.manager : null}
                    size={210}
                    style={{ marginRight: '-16px', whiteSpace: 'nowrap', fontSize: '16px' }}
                    editManger={false}
                    num={getChatSingleData?.id}
                    styleIcon={{ minWidth: '20px', height: '20px' }}
                    styleSelect={{ fontSize: '16px' }}
                    text={'Добавить менеджера'}
                  />
                </div>
                <HeadUser isReverse name={chatData?.rightUser?.full_name ?? chatData?.rightUser?.name} isSelf={chatData?.rightUser?.isSelf} type={chatData?.rightUser?.type} id={chatData?.rightUser?.id} inn={chatData?.leftUser?.inn} />
              </div>
            </>
          )}
        </div>
        <InfiniteScroll
          inverse={true}
          className=""
          dataLength={messages.length}
          scrollableTarget="messages"
          next={() => {
            const cursorValue = getChatMessagesData?.next?.split('cursor=')[1];
            if (cursorValue) {
              setCursor(decodeURIComponent(cursorValue));
            }
          }}
          hasMore={true}>
          <div id="messages" className="flex flex-1 overflow-y-scroll flex-col-reverse h-2/3 p-3 overflow-auto" style={{ height: 'calc(100vh - 380px)' }} ref={chatContainerRef}>
            {messages?.map((message) => (
              <ChatMessLeft {...message} key={message?.id} setOpenUser={setOpenUser} />
            ))}
          </div>
        </InfiniteScroll>
        <div className="border-t-1 border-gray-200   sm:mb-0">
          <div className="relative flex" style={{ display: 'grid', gridTemplateColumns: 'auto 1fr auto auto', gap: '8px' }}>
            <div className="flex items-center  justify-between">
              <Menu as="div" className="relative inline-block text-left">
                <div>
                  <Menu.Button
                    className="flex justify-center items-center gap-x-1.5 rounded-full bg-white w-10 h-10 text-sm font-semibold text-button transition duration-300 ease-in-out hover:outline-none hover:border-white  hover:bg-button border border-1 hover:text-white"
                    style={{ borderColor: 'rgba(0, 178, 164, 0.3)' }}>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6 ">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM12.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM18.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0z" />
                    </svg>
                  </Menu.Button>
                </div>

                <Transition as={Fragment} enter="transition ease-out duration-100" enterFrom="transform opacity-0 scale-95" enterTo="transform opacity-100 scale-100" leave="transition ease-in duration-75" leaveFrom="transform opacity-100 scale-100" leaveTo="transform opacity-0 scale-95">
                  <Menu.Items className="absolute left-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none" style={{ bottom: 'calc(100% + 8px)' }}>
                    <div className="py-1">
                      <Menu.Item>
                        {({ active }) => (
                          <button type="button" className={classNames(active ? 'bg-gray-100 text-red-400' : 'text-red-400', ' w-full px-4 py-2 text-left text-sm flex items-center gap-3')} onClick={handleDelete}>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6">
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
                              />
                            </svg>
                            Удалить
                          </button>
                        )}
                      </Menu.Item>
                      {/* </form> */}
                    </div>
                  </Menu.Items>
                </Transition>
              </Menu>
            </div>

            <Input
              name="message"
              form={form}
              placeholder="Введите сообщение..."
              className="placeholder-gray-400 rounded-lg focus:border-button focus:outline-none block w-full p-2 m-2 ml-0 transition duration-400 ease-in-out"
              onKeyDown={(e) => {
                console.log(e.key == 'Enter');

                if (e.key == 'Enter' && !sendMessageLoading) {
                  form.handleSubmit(onSendMessage)();
                }
              }}
            />
            {isShowSendCandidate && (
              <div className="items-center flex gap-1">
                {' '}
                <button
                  type="button"
                  className="inline-flex items-center justify-center rounded-lg h-10 w-10 transition duration-500 ease-in-out text-white border-1 focus:outline-none"
                  disabled={sendMessageLoading}
                  style={{ borderColor: 'rgba(0, 178, 164, 0.7)' }}
                  onClick={() => {
                    setOpenCandidateModal(true);
                  }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                    <path fill="rgb(0, 178, 164)" d="M7.5 5C9.43 5 11 6.57 11 8.5S9.43 12 7.5 12S4 10.43 4 8.5S5.57 5 7.5 5M1 19v-2.5C1 14.57 4.46 13 7.5 13c1.18 0 2.42.24 3.5.64V19zm21 0h-8c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h5l4 4v9c0 .55-.45 1-1 1m-4-9h3v-.17L18.17 7H18z" />
                  </svg>
                </button>
              </div>
            )}

            {/* {type} */}
            <div className="items-center flex gap-1">
              <button type="button" className="inline-flex items-center justify-center rounded-lg h-10 w-10 transition duration-500 ease-in-out text-white bg-button hover:bg-button-hov focus:outline-none disabled:bg-gray-300" disabled={sendMessageLoading} onClick={form.handleSubmit(onSendMessage)}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="h-4 w-4 ml-1 transform rotate-90">
                  <path d="M10.894 2.553a1 1 0 00-1.788 0l-7 14a1 1 0 001.169 1.409l5-1.429A1 1 0 009 15.571V11a1 1 0 112 0v4.571a1 1 0 00.725.962l5 1.428a1 1 0 001.17-1.408l-7-14z"></path>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="first:tw-16"></div>
      <Modal
        className="select-user-modal"
        style={{ height: 'calc(100vh - 40px)' }}
        title={``}
        centered
        open={openCandidateModal}
        width={'100%'}
        onCancel={() => {
          setOpenCandidateModal(false);
        }}
        footer={['']}>
        <SelectionPerformer
          isSelectApplicant={true}
          title={'Выберите соискателя'}
          onSendApplicant={(val) => {
            console.log('employer id', val);
            dispatch(
              sendMessage({
                chat_id: chatId,
                content_type: 'candidate',
                candidate_id: val,
              }),
            );
          }}
          isApplicants
          onClose={() => {
            setOpenCandidateModal(false);
          }}
        />
      </Modal>
      <Modal
        className="select-user-modal"
        style={{ height: 'calc(100vh - 40px)' }}
        title={``}
        centered
        open={openUser}
        width={'100%'}
        onCancel={() => {
          setOpenUser(null);
        }}
        footer={['']}>
        <ProfileIndex userId={openUser} isEditComment />
      </Modal>
    </div>
  );
}

//   <div className="flex items-center  justify-between space-x-2">
//     <Menu as="div" className="relative inline-block text-left">
//       <div>
//         <Menu.Button className="flex justify-center items-center gap-x-1.5 rounded-full bg-white w-9 h-9 text-sm font-semibold text-button transition duration-300 ease-in-out hover:outline-none hover:border-white  hover:bg-button border border-gray-200 shadow-md hover:text-white">
//           <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6">
//             <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM12.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM18.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0z" />
//           </svg>
//         </Menu.Button>
//       </div>

//       <Transition as={Fragment} enter="transition ease-out duration-100" enterFrom="transform opacity-0 scale-95" enterTo="transform opacity-100 scale-100" leave="transition ease-in duration-75" leaveFrom="transform opacity-100 scale-100" leaveTo="transform opacity-0 scale-95">
//         <Menu.Items className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
//           <div className="py-1">
//             <Menu.Item>
//               {({ active }) => (
//                 <Link to={`/`} className={this.classNames(active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', ' px-4 py-2 text-sm flex items-center gap-3')}>
//                   <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6">
//                     <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
//                   </svg>
//                   Аккаунт
//                 </Link>
//               )}
//             </Menu.Item>
//             {/* <form method='POST' action='#'> */}
//             <Menu.Item>
//               {({ active }) => (
//                 <button type="button" className={this.classNames(active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', ' w-full px-4 py-2 text-left text-sm flex items-center gap-3')}>
//                   <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6">
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
//                     />
//                   </svg>
//                   Удалить
//                 </button>
//               )}
//             </Menu.Item>
//             {/* </form> */}
//           </div>
//         </Menu.Items>
//       </Transition>
//     </Menu>
//   </div>;
